import { gql } from "urql";

export const MUTATION_CREATE_OWNERSHIP: any = gql(`
    mutation CreateOwnership($createOwnershipInput: CreateOwnershipInput!) {
        CreateOwnership(createOwnershipInput: $createOwnershipInput) {
            _id
        }
    }
`)

export const MUTATION_UPDATE_OWNERSHIP: any = gql(`
    mutation UpdateOwnership($updateOwnershipInput: UpdateOwnershipInput!) {
        UpdateOwnership(updateOwnershipInput: $updateOwnershipInput) {
            _id
            name
            lastname
            ssn
            phone
            email
            address
            dateBirth
            state
        }
    }
`)